import { injectable, multiInject } from 'inversify';
import * as Api from "@/app/interaction/api";

@injectable()
export class IncludeComponentsService implements Api.IncludeComponentsHandlerInterface {
  @multiInject(Api.IncludeComponentsHandlerSymbol)
  private handlers: Api.IncludeComponentsHandlerInterface[];

  public async includeComponents($parsedContent: any, cancel: Api.CancelToken) {
    let components: Vue[] = []

    for (let handler of this.handlers) {
      const created = await handler.includeComponents($parsedContent, cancel)
      if (created) {
        components.push(...created)
      }      
    }

    return components
  }
}

export const IncludeComponentsServiceSymbol = Symbol.for('IncludeComponentsService');
